var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card p-1 pt-2 mb-0 h-100"},[(_vm.data_updated)?_c('div',[_c('apexchart',{attrs:{"width":"100%","height":"200","type":"area","options":_vm.options,"series":_vm.series}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }